import { customAxiosBE } from "../config";

export async function searchTicketsApi(payload, params) {
    return customAxiosBE.post(`/ticket/search?${params}`, payload)
}

export async function getLastIssuedTicketApi(cashier) {
    return customAxiosBE.get(`/ticket/last-issued-ticket?cashier=${cashier}`)
}

export async function createReservationApi(payload) {
    return customAxiosBE.post(`/presale/complex`, payload)
}

export async function createFutureReservationApi(payload) {
    return customAxiosBE.post(`/ticket/future-reservation`, payload)
}

export async function findAllReservationsByPassenger(payload) {
    return customAxiosBE.post(`/ticket/linked-reservations`, payload)
}

export async function postTicketReleaseAPI(data) {
    return customAxiosBE.post(`ticket/reservation/cancel`, data)
}

export async function changeReservationApi(payload) {
    return customAxiosBE.post(`/ticket/reservation/change-seat`, payload)
}

export async function cancelReservationApi(id) {
    return customAxiosBE.post(`/ticket/${id}/reservation/cancel`)
}

export async function checkIfHaveOutbound(ticketId) {
    return customAxiosBE.get(`/ticket/checkIfHaveOutbound/${ticketId}`)
}

export async function issueCopyTicketAPI(ticketId) {
    const numericId = ticketId.replace(/\D/g, ""); //jer ticket id je sad M1234 ili T1234
    return customAxiosBE.post(`/ticket/${numericId}/copy`);
}


export async function getTicketsByInvoiceNumber(invoiceNumber) {
    return customAxiosBE.get(`/ticket/invoiceNumber/${invoiceNumber}`)
}

export async function updateReservationAPI(data) {
    return customAxiosBE.post(`/ticket/reservation/update`, data)
}

export async function cancelReservationAPI(ticketId) {
    return customAxiosBE.post(`/ticket/${ticketId}/reservation/cancel`)
}

export async function verifyTicket(data) {
    return customAxiosBE.post(`/ticket/verify`, data)
}

export async function soldInRatePeriod(data) {
    return customAxiosBE.post(`/ticket/sold-in-rate-period`, data)
}

export async function getDepartureSummaryApi(tripId, date, depStationId, location) {
    let url = `/ticket/departure-summary?tripId=${tripId}&date=${date}&depStationId=${depStationId}`;
    if (location) {
        url += `&location=${encodeURIComponent(location)}`;
    }
    return customAxiosBE.get(url);
}

export async function fetchTicketDetails(ticketIds) {
    if (!ticketIds || ticketIds.length === 0) {
        return [];
    }

    // return console.log(ticketIds, "TICKET IDSs")
    return customAxiosBE.get(`/boughtTicket/details?ids=${ticketIds.join(',')}`)
}
